// extracted by mini-css-extract-plugin
export default {"content":"SubmissionResult_content__AQ12g","title":"SubmissionResult_title__vwSm9","message":"SubmissionResult_message__gjOoh","button":"SubmissionResult_button__ZtI6+"};